<template>
  <div class="my-3">
    <b-row align-v="center">
      <b-col :sm="labelWidth" class="text-left">
        <label :class="validationStyle" class=" mb-0 align-middle">{{label}} <span v-if="required&&label" :class="validationState?'form-valid':'form-invalid'" style="font-size: 1rem;">*</span></label>
      </b-col>
      <b-col :sm="inputWidth">
        <b-form-input :type="typeFormat" :value="value" class="FITInput" v-bind:class="{ disabled: disabled }" :placeholder="placeholder" :disabled="disabled" :state="validationState" @input="change($event)"></b-form-input>
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="end">
      <b-col :sm="inputWidth">
        <span class="form-invalid" v-if="validationState==false">{{errorMsg}}<br/></span>
<!--                  <span v-if="validatorLength > 0"> {{validatorObject}} </br> {{validationState}}  </br> </span>
 --><span style="display: none;">{{getRuleByField}}{{validatorObject}}</span>
<!--                  <span>{{this.fieldInput}}</span>
 --></b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import { mapGetters } from 'vuex';
import { required, minLength, maxLength, minValue, maxValue, numeric, email, alphaNum, between, decimal, helpers } from 'vuelidate/lib/validators'
import $ from 'jquery'
import FITValidationBus from './FITValidationBus';
const policy = helpers.regex('policy', /^[a-zA-Z0-9-]+$/);
const ignoreGroup = [
  'caseDetail',
  'createCase',
];
export default {
  name: 'FITTextInput',
  props: {
    label: String,
    type: { type: String, default: "text" }, // number / email / telephone, default : Text
    rule: { type: Object, default: function() { return {} } },
    /**  
          { 
          required: true, (boolean)
          minLength: 4, (int)
          maxLength: 8, (int)
          minValue: 200, (int)
          maxValue: 20000, (int)
          numeric:true (boolean)      // numeric only
          decimal:true (boolean)  
          email:true (boolean)
          alphaNum: true (boolean)
          between: [ min , max ] (Array)
          policy:true (boolean)
          }
    **/

    //  Validation Result & Vuex
    field: String,
    vuexObject: { type: String, default: "default" },
    vuexModule: { type: String, default: "Validation" },
    vuexMutation: { type: String, default: "setValidationResult" },
    placeholder: String,
    disabled: Boolean,
    width: {
      type: Number,
      default: 10
    },
    value: [String, Number], // Fetch v-model init Value
  },
  data() {
    return {
      inputWidth: this.width,
      // validationState: null,
      fieldInput: this.value,
      validator: {},
      // fieldChangeFlag :false,
      allowTypes: ['password'],
    }
  },
  validations() {
    if (this.validatorLength > 0) {
      return {
        fieldInput: this.validationArray,
      }
    } else {
      return {
        fieldInput: {}
      }
    }
  },
  created() {
    this.inputTypeCheck(this.type);
  },
  mounted() {
    this.labelCheck(this.label);
    if (this.fieldInput) {
      this.$v.fieldInput.$touch();
    }

    // onListen Reset 
    FITValidationBus.$on('reset', (value) => {
      if (value) {
        // console.log("onEmit");
        if (this.$v) {
          this.$nextTick(() => { this.$v.$reset() });
        }
      }
    });

    // onListen dirty 
    FITValidationBus.$on('dirty', (value) => {
      if (value) {
        if (value == this.vuexObject) {
          // console.log(this.$v);
          this.$nextTick(() => { this.$v.fieldInput.$touch() });
          this.$emit('validation', this.validationState);

        }
      }
    });

    // Initial Dirty
    this.$nextTick(() => { this.$v.$reset() })

  },
  watch: {
    fieldInput: {
      deep: true,
      handler(val) {
        // console.log(val);
        this.$emit('input', val);
        this.$emit('validation', this.validationState);
      }
    },
    value(val) {
      this.change(val);
    }
  },
  computed: {
    // ...mapGetters(this.vuexModule,'getRuleByField'),  
    typeFormat(){
      if(this.allowTypes.includes(this.type)){
        // console.log(this.type);
        return this.type;
      }
    },
    required() {
      return this.validator.required;
    },

    getRuleByField() {
      let rules = this.$store.getters[`${this.vuexModule}/getRuleByField`];
      let result = rules(this.field);
      if (Object.keys(result).length > 0) {
        this.validator = result;
      } else {
        this.inputTypeCheck(this.type);
      }
      // console.log(this.field);
      //  console.log(result);
      return result;
    },
    getValidationFinalCheck() {
      if (!this.vuexModule) {
        return false;
      }
      if(ignoreGroup.includes( this.vuexObject)){
          return false; 
      }
      return this.$store.getters[`${this.vuexModule}/getValidationFinalCheck`];
    },
    errorMsg() {
      var msg = ""
      if (this.validationState == false) {
        $.each(this.validatorObject.$params, (key, value) => {
          if (!this.validatorObject[key]) {
            // console.log(key, value);
            switch (key) {
              case "required":
              case "numeric":
              case "decimal":
              case "email":
              case "alphaNum":
              case "policy":
                msg = this.$t(`validation.errorMsg.${key}`);
                break;
              case "minLength":
              case "minValue":
                msg = this.$t(`validation.errorMsg.${key}`) + value.min;
                break;
              case "maxLength":
              case "maxValue":
                msg = this.$t(`validation.errorMsg.${key}`) + value.max;
                break;
              case "between":
                msg = this.$t('validation.errorMsg.between') + value.min + this.$t('validation.errorMsg.between_and') + value.max;
                break;
            }
            return false;
          }
        });
      }
      return msg;
    },
    validatorObject() {
      return this.$v.fieldInput;
    },
    validationState() {
      if (this.disabled) {
        return null;
      }
      if (this.validatorLength <= 0) {
        return null;
      }
      if (this.getValidationFinalCheck) {
        this.$v.fieldInput.$touch();
      }
      // Valdiation State Check
      let dirty = this.$v.fieldInput.$dirty;
      let invalid = this.$v.fieldInput.$invalid;
      let state = null;
      // console.log(this.field + " " + invalid);
      // console.log(this.$v.fieldInput);
      if (!dirty) {
        state = null;
      } else {
        if (invalid) {
          state = false;
        } else {
          if (!this.fieldInput) {
            state = null;
            if (this.fieldInput == 0) {
              state = true;
            }
          } else {
            state = true;
          }
        }
      }

      // Update to Vuex
      if (this.field) {
        // console.log("update vuex")
        this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
          object: this.vuexObject,
          field: this.field,
          result: state,
        });
      }
      return state;
    },
    validatorLength() {
      return Object.keys(this.validator).length;
    },
    validationArray() {
      var obj = {};
      $.each(this.validator, function(key, value) {
        // console.log(key,value);
        switch (key) {
          case "required":
            obj = { ...obj, ...{ required } };
            break;
          case "numeric":
            obj = { ...obj, ...{ numeric } };
            break;
          case "decimal":
            obj = { ...obj, ...{ decimal } };
            break;
          case "email":
            obj = { ...obj, ...{ email } };
            break;
          case "alphaNum":
            obj = { ...obj, ...{ alphaNum } };
            break;
          case "policy":
            obj = { ...obj, ...{ policy } };
            break;
          case "minLength":
            obj.minLength = minLength(value);
            break;
          case "maxLength":
            obj.maxLength = maxLength(value);
            break;
          case "minValue":
            obj.minValue = minValue(value);
            break;
          case "maxValue":
            obj.maxValue = maxValue(value);
            break;
          case "between":
            obj.between = between(value[0], value[1]);
            break;
        }
      })
      // console.log(obj);
      return obj;
    },
    validationStyle() {
      if (this.validationState == null) { return; }
      if (this.validationState == true) { return 'form-valid'; }
      if (this.validationState == false) { return 'form-invalid'; }
    },
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    externalCheck(value) {
      if (value) {
        this.$v.fieldInput.$touch();
      }
    },
    inputTypeCheck(type) {
      // console.log(type);
      if(Object.keys(this.rule).length > 0){
        this.validator = this.rule;
        return;
      }
      switch (type) {
        case "telephone":
          this.validator = {
            numeric: true,
            minValue: 0,
            maxLength: 15,
            minLength: 8,
          }
          break;

        case "currency":
          this.validator = {
            decimal: true,
          }
          break;

        case "number":
          this.validator = {
            numeric: true,
          }
          break;
        case "decimal":
          this.validator = {
            decimal: true,
          }
          break;
        case "email":
          this.validator = {
            email: true,
          }
          break;
        case "alphaNum":
          this.validator = {
            alphaNum: true,
          }
        case "policy":
          this.validator = {
            policy: true,
          }
          break;
        case "password":
          this.validator = {
            required:true,
            minLength:6 
          }
        break;
        case "text":
          break;
      }
      // if(this.required == true){
      //   // console.log(this.required);
      //   this.validator = {...this.validator,...{required}};
      // }
    },
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    //   change(event) {
    //     // this. = event.trim();
    //     console.log(event);
    //     this.$emit('input', event);
    //     this.$emit('validation', this.validationState);
    //     if( (this.vuexObject)&&(this.vuexModule)&&(this.vuexMutation)){
    //       this.$store.commit(`${this.vuexModule}/${this.vuexMutation}`, {
    //                     array: this.vuexObject,
    //                     label:this.labelName,
    //                     result: this.validationState,
    //     });
    //       // console.log(`${this.vuexModule}/${this.vuexMutation}`);
    //       // console.log(this.vuexObject);

    //   // }
    // }
    change(event) {
      // if (event) {
          this.$v.fieldInput.$model = event;
      // }else{
      //     this.$v.fieldInput.$model = "";
      // } 
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/Form/FITTextInput.vue